import axios from 'axios';
import apiUrl from '../base_url';

const get = (path, params) => axios.get(`${apiUrl}serverside/${path}`, params ? { params } : undefined);
const post = (path, data) => axios.post(`${apiUrl}serverside/${path}`, data);

export const getSections = (examId) =>
  get('getsection.php', { exam_id: examId });

export const getDashboardCategory = (examId) =>
  get('dashboard_category.php', { exam_id: examId });

export const getTimeBackup = (examId, regid) =>
  get('time_backup.php', { exam_id: examId, regid });

export const getMarkedBackup = (examId, regid) =>
  get('marked_backup.php', { exam_id: examId, regid });

export const getSavedBackup = (examId, regid) =>
  get('save_backup.php', { exam_id: examId, regid });

export const getVisitedBackup = (examId, regid) =>
  get('visited_backup.php', { exam_id: examId, regid });

export const getQuestions = (sectionId, index) => {
  const params = { sec_id: sectionId };
  if (index !== undefined && index !== null) {
    params.index = index;
  }
  return get('getquestion.php', params);
};

export const saveQuestion = (data) => post('savequestion.php', data);
export const markQuestion = (data) => post('markquestion.php', data);
export const visitQuestion = (data) => post('visitedquestion.php', data);
export const submitTest = (data) => post('submittest.php', data);

export const deleteResponse = (examId, regid, qId) =>
  axios.delete(`${apiUrl}serverside/delete_response.php`, {
    params: { exam_id: examId, regid, q_id: qId },
  });

export const saveTemporaryExam = (data) => post('tempexam.php', data);
